module.exports = __webpack_public_path__ + "media/goodAnswer.474a2f07.mp3";